import axios from "axios";
import {
  InvoiceStatus,
  PaymentType,
  QuotationStatus,
} from "../generated/graphql";

export const tokenRetrievalRequest = () => {
  return axios.get(
    `${process.env.REACT_APP_PUBLIC_DOMAIN}/sanctum/csrf-cookie`,
    {
      withCredentials: true,
    }
  );
};

export function getQuotationStatusName(status: QuotationStatus) {
  switch (status) {
    case QuotationStatus.Canceled:
      return "Canceled";
    case QuotationStatus.Confirmed:
      return "Confirmed";
    case QuotationStatus.Hold:
      return "Hold";
    default:
      return status;
  }
}

export function getQuotationStatusColorScheme(status: string) {
  switch (status) {
    case QuotationStatus.Canceled:
      return "red";
    case QuotationStatus.Confirmed:
      return "green";
    default:
      return "gray";
  }
}

export function getInvoiceStatusName(status: InvoiceStatus) {
  switch (status) {
    case InvoiceStatus.Canceled:
      return "Canceled";
    case InvoiceStatus.Paid:
      return "Paid";
    case InvoiceStatus.Unpaid:
      return "Unpaid";
    default:
      return status;
  }
}

export function getInvoiceStatusColorScheme(status: InvoiceStatus) {
  switch (status) {
    case InvoiceStatus.Canceled:
      return "red";
    case InvoiceStatus.Paid:
      return "green";
    default:
      return "gray";
  }
}

export function getPaymentTypeName(paymentType: PaymentType) {
  switch (paymentType) {
    case PaymentType.Credit:
      return "Credit";
    case PaymentType.Cash:
      return "Cash";
    default:
      return paymentType;
  }
}
